var g_wamp = null;
var g_wamp_defaultTimeout = 60*1000;
var g_wamp_latestErrorCode;
var g_wamp_connected = false;
var g_wamp_tickUserOnHeartbeat = false;
var g_wamp_latestWampTickTimestamp = null;
var g_wamp_heartbeatTimeout = null;
var g_wamp_connectionCheckTimeout = null;

function _wampExceptionToErrorCode(e) {
	// This is just a wrapper so that the codes are unified and can be used with other 
	// libraries in the future
	var ret = 'Unknown';
	
	if (e.name == 'ClientError') {
		ret = 'ClientError';
	} else if (e.name == 'UriError') {
		ret = 'UriError';
	} else if (e.name == 'NoBrokerError') {
		ret = 'NoBrokerError';
	} else if (e.name == 'NoCallbackError') {
		ret = 'NoCallbackError';
	} else if (e.name == 'InvalidParamError') {
		ret = 'InvalidParamError';
	} else if (e.name == 'NoSerializerAvailableError') {
		ret = 'NoSerializerAvailableError';
	} else if (e.name == 'NonExistUnsubscribeError') {
		ret = 'NonExistUnsubscribeError';
	} else if (e.name == 'NoDealerError') {
		ret = 'NoDealerError';
	} else if (e.name == 'RPCAlreadyRegisteredError') {
		ret = 'RPCAlreadyRegisteredError';
	} else if (e.name == 'NonExistRPCUnregistrationError' 
		|| e.name == 'NonExistRPCInvocationError' 
		|| e.name == 'NonExistRPCReqIdError') {
		ret = 'NonExistRPCError';
	} else if (e.name == 'NoRealmError') {
		ret = 'NoRealmError';
	} else if (e.name == 'NoWsOrUrlError') {
		ret = 'NoWsOrUrlError';
	} else if (e.name == 'NoCRACallbackOrIdError') {
		ret = 'NoCRACallbackOrIdError';
	} else if (e.name == 'ChallengeExceptionError') {
		ret = 'ChallengeExceptionError';
	} else if (e.name == 'PPTNotSupportedError' 
		|| e.name == 'PPTInvalidSchemeError' 
		|| e.name == 'PPTSerializerInvalidError' 
		|| e.name == 'PPTSerializationError') {
		ret = 'PPTError';
	} else if (e.name == 'ProtocolViolationError') {
		ret = 'ProtocolViolationError';
	} else if (e.name == 'AbortError') {
		ret = 'AbortError';
	} else if (e.name == 'WampError') {
		ret = 'WampError';
	} else if (e.name == 'SubscribeError') {
		ret = 'SubscribeError';
	} else if (e.name == 'UnsubscribeError') {
		ret = 'UnsubscribeError';
	} else if (e.name == 'PublishError') {
		ret = 'PublishError';
	} else if (e.name == 'RegisterError') {
		ret = 'RegisterError';
	} else if (e.name == 'UnregisterError') {
		ret = 'UnregisterError';
	} else if (e.name == 'CallError') {
		ret = 'CallError';
	} else if (e.name == 'WebsocketError') {
		ret = 'WebsocketError';
	} else if (e.name == 'Timeout') {
		ret = 'Timeout';
	}

	return ret;
}

async function _wampOnHeartbeatTimeout() {
	let res = await wamp_call('heartbeat', {
        tickUser: g_wamp_tickUserOnHeartbeat
  	});
}

function _wampScheduleHeartbeat() {
	if (g_wamp_heartbeatTimeout) {
		clearTimeout(g_wamp_heartbeatTimeout);
		g_wamp_heartbeatTimeout = null;
	}

	if (wamp_isConnected()) {
		g_wamp_heartbeatTimeout = setTimeout(_wampOnHeartbeatTimeout, 20*1000);
	} else {
		console.warn('Not connected');
	}
}

function _wampScheduleConnectionCheck() {
	if (g_wamp_connectionCheckTimeout) {
		clearTimeout(g_wamp_connectionCheckTimeout);
		g_wamp_connectionCheckTimeout = null;
	}

	if (wamp_isConnected()) {
		g_wamp_connectionCheckTimeout = setTimeout(_wampOnConnectionCheckTimeout, 5*1000);
	} else {
		console.warn('Not connected');
	}
}

function _wampOnConnectionCheckTimeout() {
	if (!g_wamp_latestWampTickTimestamp || (Date.now() - g_wamp_latestWampTickTimestamp) > 60*1000) {
		console.log('Wamp is not answering. Close connection');
		g_wamp_connectionCheckTimeout = null;
		wamp_disconnect(false);
	} else {
		_wampScheduleConnectionCheck();
	}
}

function _wampTickConnection() {
    g_wamp_latestWampTickTimestamp = Date.now();
	_wampScheduleHeartbeat();
}

function wamp_last_error_code() {
	return g_wamp_latestErrorCode;
}

async function wamp_init(url, realm, username, token, options) {
	var ret = false;
	if (g_wamp) {
		return true;
	}

	var defaultOnClose = options?.onClose;
	var onCloseCallback = () => {
		g_wamp_connected = false;
		console.log('Wamp disconnected');

		g_wamp_latestWampTickTimestamp = null
		if (g_wamp_heartbeatTimeout) {
			clearTimeout(g_wamp_heartbeatTimeout);
			g_wamp_heartbeatTimeout = null;
		}

		if (g_wamp_connectionCheckTimeout) {
			clearTimeout(g_wamp_connectionCheckTimeout);
			g_wamp_connectionCheckTimeout = null;
		}

		if (defaultOnClose) {
			defaultOnClose();
		}
	}

	// Set up a custom onClose handler which dispose the wamp client
	if (options) {
		options.onClose = onCloseCallback;
		g_wamp_tickUserOnHeartbeat = options.tickUserOnHeartbeat;
	}

	g_wamp = new Wampy(url, {
        realm: realm,
        authid: username,
	    authmethods: ['ticket'],
	    onChallenge: (method, info) => {
	        return token;
	    },
	    ...(options ?? {onClose: onCloseCallback})
	});
	
	ret = true;
	return ret;
}

async function wamp_dispose() {
	var ret = false;
	if (!g_wamp) {
		console.error('Wamp not initialized');
		return ret;
	}

	try {
		if (wamp_isConnected()) {
			console.warn('Wamp is still connected, disconnecting first');
			wamp_disconnect();
		}
	    
	    g_wamp = null;
		ret = true;
	} catch (e) {
		console.error(e);
        g_wamp_latestErrorCode = _wampExceptionToErrorCode(e);
        g_wamp = null;
	}

	return ret;
}

async function wamp_connect() {
	var ret = false;

	try {
    	await g_wamp.connect();
    	g_wamp_connected = true;
    	ret = true;

		_wampScheduleConnectionCheck();
    	_wampTickConnection();
	} catch (e) {
	    console.error(e);
	    g_wamp_latestErrorCode = _wampExceptionToErrorCode(e);
	    g_wamp_connected = false;
	}

	return ret;
}

async function wamp_disconnect(waitForDisconnect=true) {
	var ret = false;
	
	g_wamp_latestWampTickTimestamp = null
	if (g_wamp_heartbeatTimeout) {
		clearTimeout(g_wamp_heartbeatTimeout);
		g_wamp_heartbeatTimeout = null;
	}

	if (g_wamp_connectionCheckTimeout) {
		clearTimeout(g_wamp_connectionCheckTimeout);
		g_wamp_connectionCheckTimeout = null;
	}

	try {
		let p = g_wamp.disconnect();
		if (waitForDisconnect) {
			await p;
		}
	    
		ret = true;
	} catch (e) {
		console.error(e);
        g_wamp_latestErrorCode = _wampExceptionToErrorCode(e);
	}

	g_wamp_connected = false;

	return ret;
}

async function wamp_assertIsConnected() {
	var ret = false;

	if (wamp_isConnected()) {
		ret = true;
	} else {
		ret = await wamp_connect();
		if (!ret) {
			console.error('Failed to connect wamp');
		}
	}

	return ret;
}

function wamp_isInit() {
	return !!g_wamp;
}

function wamp_isConnected() {
	return g_wamp_connected;
}

async function wamp_call(method_name, payload, timeout=g_wamp_defaultTimeout) {
	var ret = null;
	if (!g_wamp) {
		throw new Error('ClientError');
	} else if (! await wamp_assertIsConnected()) {
		console.error('Wamp is not connected');
		throw new Error('Connection');
	}

	try {
	    ret = g_wamp.call(method_name, payload, {timeout: timeout});

	    if (timeout > 0) {
	    	let wampPromise = ret;
	    	// Set a custom timeout. Otherwise, the timeout won't work when the client is suddenly disconnected from the network
	    	let timer;
			ret = Promise.race([
				wampPromise,
				new Promise((_r, rej) => timer = setTimeout(rej, timeout+100, {name: 'Timeout'}))
			]).finally(() => clearTimeout(timer));
	    }

	    await ret;
	    _wampTickConnection();
	} catch (e) {
		console.error(e);
	    throw new Error(_wampExceptionToErrorCode(e));
	}

	return ret;
}

// Returns the subscription id, an integer >= 0. If it failed, it returns -1
async function wamp_subscribe(topic, onEvent, match) {
	var ret = -1;
	if (!g_wamp) {
		console.error('Wamp not initialized');
		return ret;
	} else if (! await wamp_assertIsConnected()) {
		console.error('Wamp is not connected');
		g_wamp_latestErrorCode = 'Connection';
		return ret;
	}

	try {
		let subscription;
		if (match) {
			subscription = await g_wamp.subscribe(topic, onEvent, {'match': match});
		} else {
			subscription = await g_wamp.subscribe(topic, onEvent);
		}
	    
		ret = subscription?.subscriptionId ?? -1;
	    console.log(`Subscribed to ${topic} - ${ret}`);
	} catch (e) {
		console.error(e);
        g_wamp_latestErrorCode = _wampExceptionToErrorCode(e);
	}

	return ret;
}


async function wamp_unsubscribe(topic, onEvent) {
	var ret = false;
	if (!g_wamp) {
		console.error('Wamp not initialized');
		g_wamp_latestErrorCode = 'ClientError';
		return ret;
	} else if (! await wamp_assertIsConnected()) {
		console.error('Wamp is not connected');
		g_wamp_latestErrorCode = 'Connection';
		return ret;
	}

	try {
	    await g_wamp.unsubscribe(topic, onEvent);
		ret = true;
	} catch (e) {
		console.error(topic, e);
        g_wamp_latestErrorCode = _wampExceptionToErrorCode(e);
	}

	return ret;
}

export { wamp_last_error_code, wamp_init, wamp_connect, wamp_isConnected, wamp_disconnect, wamp_dispose, wamp_isInit, wamp_call, wamp_subscribe, wamp_unsubscribe };
